// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__Ne0zq","label":"styles_label__8K3cn","slideInSearchBar":"styles_slideInSearchBar__8Q0f8"};